import { SharedProfileService } from 'src/app/shared/services/shared-profile.service';

import { Component, OnInit } from '@angular/core';
import { SharedUiService } from '../../services/shared-ui.service';
import { UIThemeEnum } from '../../models/ui.models';
import { AuthenticationService } from '../../authentication';

@Component({
  selector: 'app-user-account-menu',
  templateUrl: './user-account-menu.component.html',
  styleUrls: ['./user-account-menu.component.css']
})
export class UserAccountMenuComponent implements OnInit {
  UIThemeEnum = UIThemeEnum;
  constructor(public sharedUiService: SharedUiService, private authService: AuthenticationService, public sharedProfileService: SharedProfileService) { }

  ngOnInit() {
  }

  logout() {
    this.authService.logout();
  }
}
